import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import { OidcSecurityService } from '../auth/services/oidc.security.service';
import { UnitSimReportModel } from '../shared/models/UnitSimReportModel';
import { SearchTrafficModel } from '../shared/models/search-related/SearchTrafficModel';
import { UnitSimCancelledModel } from '../shared/models/cancelled-related/UnitSimCancelledModel';

@Injectable()
export class ReportService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public GetActiveReport = (searchParams: any): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/Active/`;
        searchParams.isReport = true;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                if (searchParams[key] instanceof Date) {
                    params.set(key, this.DateToString(val));
                } else {
                    params.set(key, val);
                }
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetActiveFullReport = (companyId: string): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ActiveReport/`;
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + companyId, options).map(res => res.json());
    }

    public GetActiveDatedReport = (companyId: string, startDate: Date, endDate: Date): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ActiveReport/`;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        params.set('companyId', companyId);
        params.set('startDate', this.DateToString(startDate));
        params.set('endDate', this.DateToString(endDate));

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetInactiveReport = (searchParams: any): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/Inactive/`;
        searchParams.isReport = true;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                if (searchParams[key] instanceof Date) {
                    params.set(key, this.DateToString(val));
                } else {
                    params.set(key, val);
                }
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetInactiveDatedReport = (companyId: string, startDate: Date, endDate: Date): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/InactiveReport/`;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        params.set('companyId', companyId);
        params.set('startDate', this.DateToString(startDate));
        params.set('endDate', this.DateToString(endDate));

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetCancelledReport = (searchParams: any): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/Cancelled/`;
        searchParams.isReport = true;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                if (searchParams[key] instanceof Date) {
                    params.set(key, this.DateToString(val));
                } else {
                    params.set(key, val);
                }
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetCancelledNonProcessedReport = (): Observable<UnitSimCancelledModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/CancelledProcessing/`;
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetCancelledDatedReport = (companyId: string, startDate: Date, endDate: Date): Observable<UnitSimReportModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/CancelledReport/`;
        this.setHeaders();

        let params: URLSearchParams = new URLSearchParams();
        params.set('companyId', companyId);
        params.set('startDate', this.DateToString(startDate));
        params.set('endDate', this.DateToString(endDate));

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetTrafficHistoryReport = (searchParams: any): Observable<SearchTrafficModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/Traffic/`;
        this.setHeaders();
        searchParams.isReport = true;
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                if (searchParams[key] instanceof Date) {
                    params.set(key, this.DateToString(val));
                } else {
                    params.set(key, val);
                }
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public UpdateCancelledNonProcessed = (): Observable<Response> => {
        this.actionUrl = `${this._configuration.Server}api/CancelledProcessing/`;
        this.setHeaders();
        let userId = this.uData.sub;
        return this._http.delete(this.actionUrl + userId, { headers: this.headers });
    }

    private DateToString(date: Date): string {
        return ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/services/reports.service.ts